import { render } from "./DownloadFiles.vue?vue&type=template&id=03fed01a&scoped=true"
import script from "./DownloadFiles.vue?vue&type=script&lang=js"
export * from "./DownloadFiles.vue?vue&type=script&lang=js"

import "./DownloadFiles.vue?vue&type=style&index=0&id=03fed01a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fed01a"]])

export default __exports__